<template>
    <div class="wallpaper-list">
        <div class="wallpaper-list__header" v-if="showTitle">
            <h2 class="view__title wallpaper-list__title">{{ __('Wallpapers') }}</h2>
        </div>

        <div class="filters wallpaper-list__filters" v-if="showFilters">
            <category-list category-type="wallpapers"
                           v-bind:active-category="categoryFilter"
                           v-bind:parent-category-name="categoryFilter"
                           v-bind:parent-id="categoryFilter"
                           v-bind:show-all="true"
                           v-if="showFilters['category']"
            />
        </div>

        <router-link class="btn has-margin-b30 is-pulled-left is-primary"
                     v-bind:to="{ name: 'wallpapers.add' }"
                     v-if="listType == 'list' && user.is_admin"
        >
            <span class="jam jam-plus"></span> {{ __('Add wallpaper') }}
        </router-link>

        <nav class="wallpaper-list__wallpapers">
            <div class="wallpaper-list__wallpaper"
                 v-bind:class="{ 'is-selected' : selectedWallpaper == wallpaper || selectedWallpapers.indexOf(wallpaper.id) !== -1 }"
                 v-for="wallpaper in wallpapers"
                 v-on:click="selectable ? { click: selectWallpaper(wallpaper) } : {}"
            >
                <img v-bind:src="'/media/wallpapers/thumbs/' + wallpaper.file" v-bind:title="wallpaper.name" />

                <span class="wallpaper-list__wallpaper__actions" v-if="showActions">
                    <a class="wallpaper-list__wallpaper__action wallpaper__action--select"
                       href="javascript: void(0);"
                       v-if="showBulkActions"
                       v-on:click.prevent="toggleSelect(wallpaper.id)"
                    >
                        <span class="jam jam-check"></span>
                    </a>
                    <a class="wallpaper-list__wallpaper__action wallpaper__action--delete"
                       href="javascript: void(0);"
                       v-on:click.prevent="openDeleteConfirmModal('delete-wallpaper-' + wallpaper.id)"
                    >
                        <span class="jam jam-close"></span>
                    </a>
                </span>
                <confirm-modal
                        v-bind:id="'delete-wallpaper-' + wallpaper.id"
                        v-bind:text="__('Are you sure you wish to delete this wallpaper?')"
                ></confirm-modal>
            </div>
        </nav>

        <a class="btn btn-primary has-margin-r30 is-pulled-left"
           v-html="
                selectedWallpapers.length == paging.to - paging.from + 1
                ? __('Select none')
                : __('Select all')
           "
           v-if="showBulkActions && wallpapers.length > 0"
           v-on:click="selectAllWallpapers"
        ></a>

        <div class="wallpaper-list__bulk-actions" v-if="showBulkActions && selectedWallpapers.length > 0">
            <a class="btn is-pulled-left"
               v-on:click="openDeleteConfirmModal('delete-selected-wallpapers')"
            >
                {{ __('Delete selected') }}
            </a>
            <confirm-modal
                    v-bind:id="'delete-selected-wallpapers'"
                    v-bind:text="__('Are you sure you wish to delete all selected wallpapers?')"
            ></confirm-modal>
        </div>

        <p v-if="!wallpapers">{{ __('Loading wallpapers&hellip;') }}</p>
        <p v-if="wallpapers && wallpapers.length == 0">{{ __('You have no wallpapers.') }}</p>

        <paging v-bind:paging="paging" v-if="showPaging"></paging>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import categoryList from './CategoryList.vue';
    import confirmModal from '../elements/ConfirmModal.vue';
    import paging from '../elements/Paging.vue';

    export default {
        components: {
            categoryList,
            confirmModal,
            paging
        },
        created: function () {
            // attach event listeners
            eventBus.$on('confirm', this.handleDelete);
        },
        data: function () {
            return {
                categoryFilter: this.category,
                paging: {
                    current: 1,
                    from: 1,
                    lastPage: 1,
                    perPage: this.showPaging ? 50 : 0,
                    to: 1,
                    total: 0
                },
                selectedWallpaper: null,
                selectedWallpapers: [],
                wallpapers: []
            }
        },
        methods: {
            getWallpapers: function (resetPaging = false) {
                if (this.categoryFilter || this.paging.perPage != 0) {
                    this.wallpapers = [];
                    if (resetPaging) {
                        this.paging.current = 1;
                    }

                    let filters = {};

                    if (this.categoryFilter) {
                        filters.category = this.categoryFilter;
                    }

                    eventBus.$emit('show-loader');

                    this.$http.get(this.apiUrl + '/wallpapers', {
                        params: {
                            filters: filters,
                            page: this.paging.current,
                            perPage: this.paging.perPage,
                        }
                    }).then(function (response) {
                        this.paging.from = response.body.original.from;
                        this.paging.lastPage = response.body.original.last_page;
                        this.paging.to = response.body.original.to;
                        this.paging.total = response.body.original.total;
                        this.wallpapers = response.body.original.data;

                        eventBus.$emit('hide-loader');
                    }.bind(this), function (response) {
                        eventBus.$emit(
                                'show-alert',
                                'error',
                                this.__('There was an error retrieving data from the server.')
                        );

                        eventBus.$emit('hide-loader');
                    });
                }
            },
            handleDelete: function (id) {
                this.wallpapers.forEach(function (wallpaper) {
                    if (
                        id == 'delete-wallpaper-' + wallpaper.id
                        || (
                            id == 'delete-selected-wallpapers'
                            && this.selectedWallpapers.indexOf(wallpaper.id) !== -1
                        )
                    ) {
                        eventBus.$emit('show-loader');

                        this.$http.delete(this.apiUrl + '/wallpapers/' + wallpaper.id).then(function (response) {
                            this.paging.to--;
                            this.paging.total--;

                            this.selectedWallpapers = this.selectedWallpapers.filter(function (wallp) {
                                return wallpaper.id != wallp.id;
                            }.bind(this));

                            this.wallpapers = this.wallpapers.filter(function (wallp) {
                                return wallpaper.id != wallp.id
                            }.bind(this));

                            eventBus.$emit('hide-loader');
                        }.bind(this), function (response) {
                            eventBus.$emit(
                                    'show-alert',
                                    'error',
                                    this.__('There were some errors sending data to server.')
                            );

                            eventBus.$emit('hide-loader');
                        });
                    }
                }.bind(this));
            },
            init: function () {
                this.getWallpapers();
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            selectAllWallpapers: function () {
                if (this.selectedWallpapers.length == this.paging.to - this.paging.from + 1) {
                    this.selectedWallpapers = [];
                } else {
                    this.wallpapers.forEach(function (wallpaper) {
                        if (this.selectedWallpapers.indexOf(wallpaper.id) == -1) {
                            this.selectedWallpapers.push(wallpaper.id);
                        }
                    }.bind(this));
                }
            },
            selectWallpaper: function (wallpaper) {
                this.selectedWallpaper = wallpaper;

                this.$parent.selectedWallpaper = this.selectedWallpaper.file;
            },
            toggleSelect: function (id) {
                if (this.selectedWallpapers.indexOf(id) !== -1) {
                    this.selectedWallpapers = this.selectedWallpapers.filter(function (wallpaper) {
                        return wallpaper.id != id;
                    }.bind(this));
                } else {
                    this.selectedWallpapers.push(id);
                }
            },
            updateCategory: function (category) {
                this.categoryFilter = category;
            },
            updatePaging: function (newPage, perPage) {
                if (newPage || perPage != this.paging.perPage) {
                    if (newPage) {
                        this.paging.current = newPage;
                    }
                    this.paging.perPage = perPage;

                    this.getWallpapers();
                }
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            listType: {
                default: 'list',
                type: String
            },
            selectable: {
                default: true,
                type: Boolean
            },
            showActions: {
                default: true,
                type: Boolean
            },
            showBulkActions: {
                default: false,
                type: Boolean
            },
            showFilters: {
                default: null,
                type: Object
            },
            showPaging: {
                default: false,
                type: Boolean
            },
            showTitle: {
                default: true,
                type: Boolean
            }
        },
        watch: {
            category: function () {
                this.categoryFilter = this.category;
            },
            categoryFilter: function () {
                this.getWallpapers(true);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/WallpaperList.vue